import { connect } from "react-redux";
import "./chartStyle.css";
import SliderWithInput from "../SliderWithInput";
import { TextField } from "@mui/material";
import SwitchWithInput from "../SwitchWithInput";
import { Dispatch } from "redux";
import { updateBoxPlotStyleOptions } from "../../../redux/ChartPoperties/ChartControlsActions";
import {
  ChartOptionsProps,
  ChartOptionsStateProps,
} from "../CommonInterfaceForChartOptions";
import { ChartConBoxPlotChartControls } from "../../../redux/ChartPoperties/ChartControlsInterface";
import { handleKeyDown } from "../../CommonFunctions/CommonFunctions";
// import CSS from "csstype";

const textFieldInputProps = {
  style: {
    height: "2rem",
    flex: 1,
    padding: "4px 8px 2px 8px",
    width: "4rem",
    fontSize: "14px",
  },
};

const customTextFieldStyle = {
  borderColor: "#2bb9bb",
  "& .MuiInputBase-root": {
    "&.Mui-focused fieldset": {
      borderColor: "#2bb9bb",
    },
  },
};

const customInputLabelStyle = {
  "&.Mui-focused": {
    color: "#2bb9bb", // Change label color when focused
  },
};

interface BoxPlotChartAction {
  updateBoxPlotStyleOptions: (
    propKey: string,
    option: string,
    value: any
  ) => void;
}

const BoxPlotChartStyles = ({
  // state
  chartControls,
  tabTileProps,

  // dispatch
  updateBoxPlotStyleOptions,
}: ChartOptionsProps & BoxPlotChartAction) => {
  var propKey: string = `${tabTileProps.selectedTabId}.${tabTileProps.selectedTileId}`;
  var boxStyle: ChartConBoxPlotChartControls =
    chartControls.properties[propKey].boxPlotChartControls;

  return (
    <div className="optionsInfo">
      <div className="optionDescription" style={{ padding: "5px 6% 5px 4%" }}>
        <label
          htmlFor="enableDisable"
          className="enableDisableLabel"
          style={{ marginRight: "15px", paddingLeft: "0", marginTop: "10px" }}
        >
          Flip Axis
        </label>
        </div>
        <div style={{marginLeft: '-30px'}}>
        <SwitchWithInput
          isChecked={boxStyle.flipAxis}
          onSwitch={() => {
            updateBoxPlotStyleOptions(propKey, "flipAxis", !boxStyle.flipAxis);
          }}
        />
      </div>
      <div>
        <div className="optionDescription" style={{marginTop: "0"}}>Box Width</div>
        <div className="inputFieldContainer">
          <TextField
            type="number"
            value={boxStyle.minBoxWidth}
            onKeyDown={(event: React.KeyboardEvent<HTMLInputElement>) => handleKeyDown(event)}
            onChange={(e) => {
              updateBoxPlotStyleOptions(propKey, "minBoxWidth", e.target.value);
            }}
            label="Min"
            InputLabelProps={{ shrink: true, sx: customInputLabelStyle }}
            inputProps={{ ...textFieldInputProps }}
            sx={{
              ...customTextFieldStyle,
              ...{
                "& .MuiOutlinedInput-input": {
                  padding: "16.5px 14px", // Consistent padding for all browsers
                },
                // Firefox-specific styling
                "@supports (-moz-appearance: none)": {
                  "& .MuiOutlinedInput-input": {
                    padding: "16.5px 2px 16.5px 14px",
                  },
                },
              },
            }}
          />
          <TextField
            type="number"
            value={boxStyle.maxBoxWidth}
            onKeyDown={(event: React.KeyboardEvent<HTMLInputElement>) => handleKeyDown(event)}
            onChange={(e) => {
              updateBoxPlotStyleOptions(propKey, "maxBoxWidth", e.target.value);
            }}
            label="Max"
            InputLabelProps={{ shrink: true, sx: customInputLabelStyle }}
            inputProps={{ ...textFieldInputProps }}
            sx={{
              ...customTextFieldStyle,
              ...{
                "& .MuiOutlinedInput-input": {
                  padding: "16.5px 14px", // Consistent padding for all browsers
                },
                // Firefox-specific styling
                "@supports (-moz-appearance: none)": {
                  "& .MuiOutlinedInput-input": {
                    padding: "16.5px 2px 16.5px 14px",
                  },
                },
              },
            }}
          />
        </div>
      </div>

      <div className="optionDescription" style={{marginTop: "5px"}}>Border Width</div>
      <SliderWithInput
        percent={true}
        sliderValue={boxStyle.boxborderWidth}
        sliderMinMax={{ min: 1, max: 10, step: 1 }}
        changeValue={(value) =>
          updateBoxPlotStyleOptions(propKey, "boxborderWidth", value)
        }
      />
    </div>
  );
};
const mapStateToProps = (state: ChartOptionsStateProps, ownProps: any) => {
  return {
    chartControls: state.chartControls,
    tabTileProps: state.tabTileProps,
  };
};

const mapDispatchToProps = (dispatch: Dispatch<any>) => {
  return {
    updateBoxPlotStyleOptions: (propKey: string, option: string, value: any) =>
      dispatch(updateBoxPlotStyleOptions(propKey, option, value)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(BoxPlotChartStyles);
